import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { useAirlineServices,useAirportConsultancy,useCommercialLeasing } from "../BusinessOppurtunities/BusinessOppurtunities.hook";
import { fields } from "../MediaCentre/constants";
import { post, put } from "~/Services";
import {Agencies} from "./Agencies/Agencies";
import {Airlines} from "./Airlines/Airlines";
import {Cargo} from "./Cargo/Cargo";
import {GroundHolders} from "./GroundHolders/GroundHolders";
import { Icon } from "@iconify/react";


export const StakeHolder = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const { data: airlineServicesData, isLoading: isLoadingAirlineServices } = useAirlineServices();
  const { data: airportConsultancyData, isLoading: isLoadingAirportConsultancy } = useAirportConsultancy();

  useEffect(() => {
    if (query.get("id")) {
      return;
    }
    if (!query.get("activeTab")) {
        navigate(`/dedicated/corporate/stakeholders?activeTab=agencies&subActiveTab=agenciesPageHeading`, {
          replace: true,
        });
    } else{
      if(query.get('activeTab')==='agencies'){
        navigate(`/dedicated/corporate/stakeholders?activeTab=agencies&subActiveTab=${query.get('subActiveTab')||'agenciesPageHeading'}`, {
          replace: true,
        });
      }
      if(query.get('activeTab')==='airlines'){
        navigate(`/dedicated/corporate/stakeholders?activeTab=airlines&subActiveTab=${query.get('subActiveTab')||'airlinesPageHeading'}`, {
          replace: true,
        });
      }
      if(query.get('activeTab')==='cargo'){
        navigate(`/dedicated/corporate/stakeholders?activeTab=cargo&subActiveTab=${query.get('subActiveTab')||'cargoPageHeading'}`, {
          replace: true,
        });
      }
      if(query.get('activeTab')==='groundHandlers'){
        navigate(`/dedicated/corporate/stakeholders?activeTab=groundHandlers&subActiveTab=${query.get('subActiveTab')||'groundHandlersPageHeading'}`, {
          replace: true,
        });
      }
    }
  }, [query.get('activeTab'), query.get('subActiveTab')]);

  const items = [
    {
      label: "Agencies",
      key: "agencies",
      children: (
        // <DynamicForm
        //   config={AirlineServicesConfig}
        //   onSubmit={(data, buttonValue) =>
        //     onSubmit(
        //       data,
        //       `https://corporate-nprod-cms.myairports.com.my/api/page-content/102`,
        //       "UPDATE",
        //       "PATCH",
        //       buttonValue == "save" ? "DRAFT" : "PENDING"
        //     )
        //   }
        // />
        <Agencies/>
      ),
    },
    {
      label: "Airlines",
      key: "airlines",
      children: (
        // <DynamicForm
        //   config={AirlineServicesConfig}
        //   onSubmit={(data, buttonValue) =>
        //     onSubmit(
        //       data,
        //       `https://corporate-nprod-cms.myairports.com.my/api/page-content/102`,
        //       "UPDATE",
        //       "PATCH",
        //       buttonValue == "save" ? "DRAFT" : "PENDING"
        //     )
        //   }
        // />
        <Airlines/>
      ),
    },
    {
      label: "Cargo",
      key: "cargo",
      children: (
        // <DynamicForm
        //   config={AirportConsultancyConfig}
        //   onSubmit={(data, buttonValue) =>
        //     onSubmit(
        //       data,
        //       `https://corporate-nprod-cms.myairports.com.my/api/page-content/94`,
        //       "UPDATE",
        //       "PATCH",
        //       buttonValue == "save" ? "DRAFT" : "PENDING"
        //     )
        //   }
        // />
        <Cargo/>
      ),
    },
    {
      label: "Ground Handlers",
      key: "groundHandlers",
      children: (
        // <DynamicForm
        //   config={CommercialLeasingConfig}
        //   onSubmit={(data, buttonValue) =>
        //     onSubmit(
        //       data,
        //       `https://corporate-nprod-cms.myairports.com.my/api/page-content/95`,
        //       "UPDATE",
        //       "PATCH",
        //       buttonValue == "save" ? "DRAFT" : "PENDING"
        //     )
        //   }
        // />
        <GroundHolders/>
      ),
    },
  ];

  const handleProductManagement=(activeTab:any, subActiveTab:any)=>{
    if(activeTab==='groundHandlers' && subActiveTab==='groundHandlersPageContent'){
      return (<Button
       onClick={() => {
         navigate("/dedicated/corporate/stakeholders/groundHandlers/add");
       }}
       icon={<Icon icon={"lucide:plus"} />}
       >
         Add Ground Holders
       </Button>)
    } else if(activeTab==='cargo' && subActiveTab==='cargoPageContent'){
      return (<Button
       onClick={() => {
         navigate("/dedicated/corporate/stakeholders/cargo/add");
       }}
       icon={<Icon icon={"lucide:plus"} />}
       >
         Add Cargo
       </Button>)
    } else if(activeTab==='airlines'&& subActiveTab==='airlinesPageContent'){
      return (<Button
       onClick={() => {
         navigate("/dedicated/corporate/stakeholders/airlines/add");
       }}
       icon={<Icon icon={"lucide:plus"} />}
       >
         Add Airlines
       </Button>)
    } else if(activeTab==='agencies' && subActiveTab==='agenciesPageContent'){
      return (<Button
       onClick={() => {
         navigate("/dedicated/corporate/stakeholders/agencies/add");
       }}
       icon={<Icon icon={"lucide:plus"} />}
       >
         Add Agencies
       </Button>)
    }
  }

  return (
    <ContentWrapper
      title={"Stake Holders"}
      loading={isLoadingAirlineServices || isLoadingAirportConsultancy}
      actionItems={handleProductManagement(query.get('activeTab'), query.get('subActiveTab'))}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
